import { graphql } from '../createShopGraphqlDocument';

export const loginToShopApiOmsDocument = graphql(
  `
    mutation LoginToShop($username: String!, $password: String!) {
      login(username: $username, password: $password) {
        __typename
        ... on CurrentUser {
          id
          identifier
        }
      }
    }
  `,
);
